import React from 'react';
import { Box, Typography, Container, Card, CardContent } from '@mui/material';
import LoginForm from '../components/Auth/LoginForm';

function LoginPage() {
    return (
        <Container component="main" maxWidth="xs" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
            <Card sx={{ width: '100%', p: 3, mt: -8 }}> {/* p: padding, mt: margin-top (ajustar si Layout no tiene Navbar) */}
                <CardContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
                        <Typography component="h1" variant="h5">
                            Iniciar Sesión
                        </Typography>
                    </Box>
                    <LoginForm />
                </CardContent>
            </Card>
        </Container>
    );
}

export default LoginPage;